<template>
 <div class="faq">
   <div class="top-modules">
      <div class="category tab-inner">
        <div
          v-for="(item,index) in category"
          :key="index"
          :class="{on: currentIndex == index }"
          :style="getActiveStyle(index)"
          class="category-item tab-item"
          @click="categoryHandle(index)"
        >{{item.label}}</div>
      </div>
      <div class="modules-right">
        <el-input
          prefix-icon="el-icon-search"
          :placeholder="$t('copyMaster.key_words')"
          v-model="keyWords"
          @keyup.enter.native="searchHandle"
          clearable
          @clear="searchHandle"
        ></el-input>
      </div>
   </div>
   <div class="issue-list">
     <el-collapse
       accordion
       v-model="activeNames"
       @change="handleChange"
       v-if="listData.length"
     >
       <el-collapse-item
         v-for="(item, index) in listData"
         :key="index"
         :title="item.question"
         :name="index"
       >
         <div
           class="issue-content"
         >{{item.answer}}</div>
       </el-collapse-item>
     </el-collapse>
     <div
       v-if="!listData.length"
       class="no-data">{{$t('root.noData')}}</div>
   </div>
   <div class="pagination-outer" v-if="total > 10">
     <div class="paginnation-left">
       <size-change @sizeChange="sizeChange"></size-change>
       <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
     </div>
     <vs-pagination
       class="pagination-box"
       :max="max"
       :total="pageSize"
       v-model="page"
     ></vs-pagination>
   </div>
 </div>
</template>

<script>
import initData from '@/mixins/initData';
import { queryFaqList } from '@/api/userCenter'
import { mapGetters } from 'vuex'
import { colorRgba, debounce } from "@/utils";

export default {
  name: "index",
  data() {
    return {
      currentIndex: 0,
      category: [
        {label: this.$t('All'), value: ''},
        {label: this.$t('faq.Agency_related'), value: 0}, // todo
        {label: this.$t('faq.Account_related'), value: 1},
        {label: this.$t('faq.Transaction_related'), value: 2},
        {label: this.$t('faq.Deposits_and_withdrawals'), value: 3},
        {label: this.$t('other'), value: 4},
      ],
      keyWords: '',
      activeNames: ['1'],
      issueList: [
                   /* {
                        title: 'Alita是外汇经济商吗？',
                        contentDetail: ' 没有任何人或任何机构能保证在全球贵金属、外汇市场的投资只盈不亏。但是MyFxtop迈投的交易达人大多都是操盘经验丰富，投资回报表现良好的投资人，复制交易可以提高盈利机率，但是无法保障100%盈利，客户须自主承担所有风险。'
                    },
                    {
                        title: '我的账号在Alita跟单会影响资金安全吗？？',
                        contentDetail: ' 没有任何人或任何机构能保证在全球贵金属、外汇市场的投资只盈不亏。但是MyFxtop迈投的交易达人大多都是操盘经验丰富，投资回报表现良好的投资人，复制交易可以提高盈利机率，但是无法保障100%盈利，客户须自主承担所有风险。'
                    },
                    {
                        title: 'Alita的交易达人能确保一直盈利吗？',
                        contentDetail: ' 没有任何人或任何机构能保证在全球贵金属、外汇市场的投资只盈不亏。但是MyFxtop迈投的交易达人大多都是操盘经验丰富，投资回报表现良好的投资人，复制交易可以提高盈利机率，但是无法保障100%盈利，客户须自主承担所有风险。'
                    },
                    {
                        title: 'Alita能保证信号方下单数据的真实性吗？',
                        contentDetail: ' 没有任何人或任何机构能保证在全球贵金属、外汇市场的投资只盈不亏。但是MyFxtop迈投的交易达人大多都是操盘经验丰富，投资回报表现良好的投资人，复制交易可以提高盈利机率，但是无法保障100%盈利，客户须自主承担所有风险。'
                    },*/
                ],
      isIb: 1,
    }
  },
  watch:{
    keyWords(val){
      if(val){
        console.log('1');
        debounce(this.searchHandle(),3000);
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'language', 'themeColor','agentRole']),
  },
  mixins: [initData],
  created(){
    if(this.agentRole !== 'IB'){
      this.isIb = 0;
      this.category = this.category.filter((item) => {
        return item.value !== 0;
      })
    }else {
      this.isIb = 1;
    }
    this.init();
  },
  methods: {
    beforeInit(){
      this.url = '/crm/reception/tCustFaq';
      this.params = {
        page: this.page - 1,
        size: this.size,
        isIb: this.isIb,
      }
      if(this.category[this.currentIndex].value !== ''){
        this.params.type = this.category[this.currentIndex].value;
      }
      if(this.keyWords){
        this.params.keyword = this.keyWords;
      }
      return true
    },
    getActiveStyle(index){
      if(index == this.currentIndex){
        return {
          backgroundColor: colorRgba(this.themeColor,0.1)
        }
      }
    },
    handleChange(val) {

    },
    categoryHandle(index){
      this.currentIndex = index;
      this.keyWords = '';
      this.page = 1;
      this.init();
    },
    searchHandle(){
      this.currentIndex = 0; //归到全部分类下
      this.page = 1;
      this.init();
    },
  },
}
</script>
<style lang="scss">
.issue-list {
  .el-collapse {
    border-top: none;
  }
  .el-collapse-item__header {
    font-size: 14px;
    color: #5E5873;
  }

  .el-collapse-item__content {
    font-size: 14px;
  }
}
</style>
<style lang="scss" scoped>
.faq {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 24px;
  /deep/ .el-collapse-item__header {
    font-weight: 600;
    height: auto!important;
    padding: 10px 0;
    line-height: 1.5!important;
  }
  .top-modules {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 24px;
    .category-item {
      display: inline;
    }
    .tab-inner {
      //flex-wrap: wrap;
    }

    .category,
    .modules-right {
      margin-bottom: 10px;
    }
  }
  .issue-list {
    min-height: 420px;
    box-sizing: border-box;

    .issue-content {
      color: #6E6B7B;
    }
  }

  .search-result {
    color: var(--theme-color,#E74B3A);
  }

  .none-data {
    height: 100%;
    line-height: 420px;
    font-size: 24px;
  }

  .pagination-outer {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
}

// 移动端
@media screen and (max-width: 768px) {
  .category {
    white-space: nowrap;
    overflow-x: scroll;
  }
}
</style>
